import { Dialog, Button, Icons, Icon, Intent } from 'construct-ui';

export const messageType = {
  WARNING: 1,
  ERROR: 2,
  INFORMATION: 3,
  CONFIRM: 4,
};

export function styledMessageComponent() {
  let handleClose = (e) => { };
  let onAction = (e) => { };
  let isOpen = false;
  let confirmButtonIntent = Intent.PRIMARY; // construct-ui component color intent, default Primary
  let message = null; //m.children - inner text or childern
  let extraProps = null;
  let title = ""; //string
  let msgType = messageType.INFORMATION; // default

  let getIcon = () => {
    const ico = {
      intent: Intent.POSITIVE,
      name: Icons.INFO,
      size: 'xl'
    };
    if (msgType == messageType.WARNING) {
      ico.intent = Intent.WARNING;
      ico.name = Icons.ALERT_TRIANGLE;
    } else if (msgType == messageType.ERROR) {
      ico.intent = Intent.NEGATIVE;
      ico.name = Icons.X_CIRCLE;
    } else if (msgType == messageType.CONFIRM) {
      ico.intent = Intent.NONE;
      ico.name = Icons.HELP_CIRCLE;
    }
    return ico;
  }

  return {
    view: (vnode) => {
      // console.log('Vnode===>', vnode)
      if (vnode.attrs.isOpen != undefined) {
        isOpen = vnode.attrs.isOpen;
      }
      if (vnode.attrs.message != undefined) {
        message = vnode.attrs.message;
      }
      if (vnode.attrs.title != undefined) {
        title = vnode.attrs.title;
      }
      if (vnode.attrs.extraProps != undefined) {
        extraProps = vnode.attrs.extraProps;
      }
      if (vnode.attrs.confirmButtonIntent !== undefined) {
        confirmButtonIntent = vnode.attrs.confirmButtonIntent;
      }
      if (vnode.attrs.handleClose) {
        handleClose = vnode.attrs.handleClose;
      }
      if (vnode.attrs.msgType) {
        msgType = vnode.attrs.msgType;
      }
      if (vnode.attrs.handleAction) {
        onAction = vnode.attrs.handleAction;
      }

      return m(Dialog, {
        isOpen: isOpen,
        onClose: handleClose,
        title: title,
        'class': 'cui-dialog-msgbox',
        transitionDuration: 200,
        closeOnOutsideClick: false,
        hasCloseButton: true,
        content: m('.row',

          m('div', [m(Icon, getIcon()),
          m('span.fw-bold.ps-2', extraProps),]),

          message
        ),
        footer: [
          m('.d-flex.justify-content-end',
            (msgType != messageType.CONFIRM) ? m(Button, {
              label: "Close",
              intent: 'primary',
              onclick: (e) => {
                isOpen = false; onClosed(e);
              }
            }) : [
              m(Button, {
                label: "Yes",
                intent: confirmButtonIntent,
                onclick: (e) => {
                  isOpen = false; onAction("YES");
                }
              }),
              m(Button, {
                label: "No",
                intent: 'primary',
                onclick: (e) => {
                  isOpen = false; onAction("NO");
                }
              })
            ]
          )
        ]
      });
    }
  }
}
